import { LoadingButton } from "@mui/lab";
import React, { useEffect, useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  CircularProgress,
  Box,
} from "@mui/material";
import ControlledStateAutocomplete from "src/components/forms/form-elements/autoComplete/ControlledStateAutocomplete";
import { getAllCustomers, updateBillingParty } from "src/queries/query";
import { toast } from "react-toastify";

const BillingPartyUpdateModal = ({ open, onClose, orderUuid, onSuccess }) => {
  const [isCustomersLoading, setCustomersIsLoading] = React.useState(false);
  const [customerObj, setCustomerObj] = React.useState();
  const [options, setOptions] = React.useState([]);
  const [isUpdating, setIsUpdating] = React.useState(false);

  const getData = async () => {
    setCustomersIsLoading(true);

    try {
      const result = await getAllCustomers();

      if (result?.status === 200) {
        setOptions(result?.data?.data?.data);
        setCustomersIsLoading(false);
      }
    } catch (error) {
      setCustomersIsLoading(false);
      console.error("Upload Error:", error.message);
    }
  };

  useEffect(() => {
    if (options.length === 0 && !isCustomersLoading) getData();
  }, []);

  const handleUpdateBillingParty = async () => {
    if (!customerObj) {
      toast.error("Please select a customer first.");
      return;
    }

    setIsUpdating(true);
    try {
      const result = await updateBillingParty(orderUuid, customerObj.uuid);
      if (result?.status === 200) {
        toast.success("Billing party updated successfully.");
        onClose();
        if (onSuccess) onSuccess();
      } else {
        toast.error("Failed to update billing party.");
      }
    } catch (error) {
      console.error("Error updating billing party:", error);
      toast.error(
        error?.response?.data?.message || "Failed to update billing party.",
      );
    } finally {
      setIsUpdating(false);
    }
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>Update Billing Party</DialogTitle>
      <DialogContent>
        <Typography variant="body2" sx={{ mb: 2 }}>
          Search and select a customer to update the billing party for this
          order.
        </Typography>
        {isCustomersLoading ? (
          <Box display="flex" justifyContent="center" py={2}>
            <CircularProgress />
          </Box>
        ) : (
          <ControlledStateAutocomplete
            setSelectedValue={setCustomerObj}
            options={options}
            label="Search Customer"
          />
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} disabled={isUpdating}>
          Cancel
        </Button>
        <LoadingButton
          variant="contained"
          loading={isUpdating}
          onClick={handleUpdateBillingParty}
        >
          Update Billing Party
        </LoadingButton>
      </DialogActions>
    </Dialog>
  );
};

export default BillingPartyUpdateModal;
